import { useTimeBasedAuthenticationConfigurationCqrsFind } from '@dreryk/egabinet-security-frontend';
import { PromiseVoidFunction } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { mfaSettingsTranslationKeys } from '../../../translations';

type MfaSettingsLoaderRenderProps = {
   timeBaseAuthenticationConfiguration: {
      activationDate: Date;
   } | null;
   refetch: PromiseVoidFunction;
};

type MfaSettingsLoaderProps = {
   readonly children: (renderProps: MfaSettingsLoaderRenderProps) => JSX.Element;
};

export const MfaSettingsLoader = (props: MfaSettingsLoaderProps): JSX.Element => {
   const {
      data: timeBasedAuthenticationConfiguration,
      loading: timeBasedAuthenticationConfigurationLoading,
      error: timeBasedAuthenticationConfigurationError,
      refetch: refetchTimeBasedAuthenticationConfiguration,
   } = useTimeBasedAuthenticationConfigurationCqrsFind();

   if (timeBasedAuthenticationConfigurationLoading || timeBasedAuthenticationConfiguration === undefined) {
      return <LoaderSpinner />;
   }

   if (timeBasedAuthenticationConfigurationError) {
      return (
         <Message
            testId={'failedToFetchMfaSettings'}
            label={mfaSettingsTranslationKeys.failedToFetchMfaSettings}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      timeBaseAuthenticationConfiguration: timeBasedAuthenticationConfiguration
         ? {
              activationDate: new Date(timeBasedAuthenticationConfiguration.activationDate),
           }
         : null,
      refetch: refetchTimeBasedAuthenticationConfiguration,
   });
};
